import {
  authentication,
  type AuthenticationClient,
  createDirectus,
  type DirectusClient,
  rest,
  type RestClient
} from '@directus/sdk'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'
import { type TTypes } from '~/types/other-types'

type TDirectusClient = DirectusClient<TTypes> & AuthenticationClient<TTypes> & RestClient<TTypes>

declare module '#app' {
    interface NuxtApp {
        $directus: TDirectusClient
    }
}

/*
  makes the Directus SDK available in all components
  uses a generated types file (directus tools > generate-types)
*/
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const baseUrl = (import.meta.server) ? config.privateApiBaseUrl : config.public.apiBaseUrl

  const directus = createDirectus<TTypes>(baseUrl)
    .with(authentication('json'))
    .with(rest())

  return {
    provide: { directus }
  }
})
